import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import { filterByCategoryName } from "../../../helpers/common";
import useStyles from "./styles";
import { dataUrl } from "../../../helpers/common";

const HomeCategories = () => {
  const classes = useStyles();

  // const menus = useSelector((state) => state.menus.menus);
  // const homeCategories = useMemo(() => {
  //   return filterByCategoryName(menus, "home-categories");
  // }, [menus]);

  const categories = useSelector((state) => state.categories.data);
  const featuredCategories = useMemo(() => {
    return categories.filter(
      (category) => category?.category_labels === "Popular"
    );
  }, [categories]);

  return (
    <div className={classes.categorySec}>
      <div className="container">
        <div className={classes.sectionHeader}>
          <h2 className={classes.heading}>Featured Categories</h2>
          <p className={classes.subheading}>
            Discover our premium collection of authentic Indian snacks
          </p>
        </div>

        <div className={classes.categoriesGrid}>
          {featuredCategories.map((category, index) => (
            <Link
              key={index}
              to={`/category/${category?.id}/${category?.url_slug}/1`}
              className={classes.categoryCard}
              style={{ background: category?.gradient }}
            >
              <div className={classes.categoryImage}>
                <img
                  src={`${dataUrl}/categories/${category?.image}`}
                  alt={category?.name}
                />
              </div>
              <div className={classes.categoryOverlay}>
                <h3 className={classes.categoryName}>{category?.name}</h3>
                <div className={classes.categoryArrow}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5 12H19M19 12L12 5M19 12L12 19"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeCategories;
